import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import DeleteModal from "components/Common/DeleteModal"
import UserListComponent from "components/User/list"
import { deleteUser, getUsers } from "store/user/user-action"

const UserList = () => {
  const dispatch = useDispatch()
  const { data, error, loading } = useSelector(state => state.user)
  const [deleteModal, setDeleteModal] = useState(false)
  const [user, setUser] = useState(null)
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(10)
  const [according, setAccording] = useState({ order: "desc", name: "id" })

  // Handle user deletion and close the delete modal
  // Dispatch delete action for the selected user
  // Close the delete modal
  const handleDeleteFunc = data => {
    if (user) {
      dispatch(deleteUser(user.id))
    }
    setDeleteModal(false)
  }

  // Set the user to be deleted and open the delete modal
  // Store the selected user for deletion
  // Open the delete confirmation modal
  const onClickDelete = data => {
    setUser(data)
    setDeleteModal(true)
  }

  // Fetches new users when a page number is clicked
  const onPageClick = link => {
    dispatch(getUsers(link.url, pageNumber, according, search))
  }

  // Updates search value when a new search is performed
  const onSearchHandler = value => {
    setSearch(value)
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // fetch new Provider Distribution Action Requests based search entered
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      dispatch(getUsers(undefined, undefined, undefined, search))
    }, 1500)

    return () => clearTimeout(delayDebounceFn)
  }, [search])

  // fetch new Provider Distribution Action Requests based page number or according changes
  useEffect(() => {
    dispatch(getUsers(undefined, pageNumber, according, search))
  }, [pageNumber, according])

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteFunc}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Breadcrumbs title={"Admin"} breadcrumbItem={"Users"} />
      {/* User List Component  */}
      <UserListComponent
        data={data}
        error={error}
        loading={loading}
        onClickDelete={onClickDelete}
        handleDeleteFunc={handleDeleteFunc}
        onPageClick={onPageClick}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
      />
    </React.Fragment>
  )
}

export default UserList
